import { render, staticRenderFns } from "./Promociones.vue?vue&type=template&id=68734cce&"
import script from "./Promociones.vue?vue&type=script&lang=js&"
export * from "./Promociones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports